import React, { useState } from 'react';

interface ClickableEmailProps {
  email: string;
  displayText?: string;
  showIcon?: boolean;
  style?: React.CSSProperties;
}

export const ClickableEmail: React.FC<ClickableEmailProps> = ({
  email,
  displayText,
  showIcon = false,
  style = {}
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy email:', err);
    }
  };

  return (
    <span
      onClick={handleCopyEmail}
      style={{
        cursor: 'pointer',
        userSelect: 'none',
        color: '#608cdf',
        textDecoration: 'underline',
        display: 'inline-block',
        ...style
      }}
      title="Click to copy email address"
    >
      {showIcon && '📧 '}
      {displayText || 'Email'}
      {copied ? (
        <span style={{ color: '#27ae60', fontSize: '0.9em', marginLeft: '5px' }}>
          ✓ Copied!
        </span>
      ) : (
        <span style={{ color: '#7f8c8d', fontSize: '0.85em', marginLeft: '5px' }}>
          (click to copy)
        </span>
      )}
    </span>
  );
};
